import { CustomerSelect } from '@/components/CustomerSelect';
import { Button } from '@/components/ui/Button';
import {
  Select,
  SelectTrigger,
  SelectValue,
  SelectContent,
  SelectItem,
} from '@/components/ui/Select';
import { useUniqueValues } from '@/hooks/useGetUniqueValues';

interface PromptsFilterProps {
  onFilterChange: (filters: {
    serviceName?: string;
    promptName?: string;
    customerId?: number;
  }) => void;
  filter?: {
    serviceName?: string;
    promptName?: string;
    customerId?: number;
  };
  contextualCustomerId?: number;
}

export function PromptsFilter({
  onFilterChange,
  filter,
  contextualCustomerId,
}: PromptsFilterProps) {
  const activeFilterCount = [
    filter?.serviceName,
    filter?.promptName,
    filter?.customerId,
  ].filter(Boolean).length;

  function clearFilters() {
    onFilterChange({
      serviceName: undefined,
      promptName: undefined,
      customerId: undefined,
    });
  }
  const { uniqueValues } = useUniqueValues();
  return (
    <div>
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-4">
        <div>
          <Select
            value={filter?.serviceName ?? ''}
            onValueChange={(value) =>
              onFilterChange({
                serviceName: value,
                promptName: filter?.promptName,
                customerId: filter?.customerId,
              })
            }
          >
            <SelectTrigger id="serviceNames" className="w-full gap-1 bg-white">
              <SelectValue placeholder="Todos os serviços" />
            </SelectTrigger>
            <SelectContent>
              {uniqueValues.serviceNames.map((serviceName) => (
                <SelectItem key={serviceName} value={serviceName}>
                  {serviceName}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>

        <div>
          <Select
            value={filter?.promptName ?? ''}
            onValueChange={(value) =>
              onFilterChange({
                promptName: value,
                serviceName: filter?.serviceName,
                customerId: filter?.customerId,
              })
            }
          >
            <SelectTrigger id="promptNames" className="w-full gap-1 bg-white">
              <SelectValue placeholder="Todos os prompts" />
            </SelectTrigger>
            <SelectContent>
              {uniqueValues.promptNames.map((promptName) => (
                <SelectItem key={promptName} value={promptName}>
                  {promptName}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>

        <div>
          <CustomerSelect
            value={
              contextualCustomerId
                ? String(contextualCustomerId)
                : filter?.customerId
                  ? String(filter.customerId)
                  : 'all'
            }
            onValueChange={(value) =>
              onFilterChange({
                serviceName: filter?.serviceName,
                promptName: filter?.promptName,
                customerId: value === 'all' ? undefined : Number(value),
              })
            }
            additionalOptions={[{ value: 'all', label: 'Todos os clientes' }]}
            disabled={Boolean(contextualCustomerId)}
          />
        </div>

        <div className="flex items-end">
          {activeFilterCount > 0 && (
            <Button variant="outline" onClick={clearFilters}>
              Clear Filters ({activeFilterCount})
            </Button>
          )}
        </div>
      </div>
    </div>
  );
}
